import React from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Leadership from './Leadership';
import PropertyTypes from './PropertyTypes';
import LocationCTA from './LocationCTA';
import Footer from './Footer';
import StateCarousel from './StateCarousel';
;



const LandingPage = () => {
  return (
    <div className="landing-page">
      <Navbar />
  <Hero />
  <StateCarousel />
  <About />
     <Services />
     <PropertyTypes/>
               <Leadership />
<LocationCTA/>
<Footer/>
    </div>
  );
};

export default LandingPage;